// App filter for a PRD thread (PRD dab8eb54): a post tagged with an app is
// about that app only; an untagged post is global and shows under every app
// view. `appId` null/"" = no filter.
export const visibleUnderApp = <P extends { appId?: string | null }>(
  posts: P[],
  appId: string | null | undefined
): P[] =>
  appId ? posts.filter((p) => !p.appId || String(p.appId) === String(appId)) : posts;
